type FilterControlsRowProps = {
  showActiveOnly: boolean;
  onShowActiveOnlyChange: (showActiveOnly: boolean) => void;
  onExpandAll: () => void;
  onCollapseAll: () => void;
};

/**
 * The controls row beneath the filter search input: a "Show active only" toggle
 * paired with "Expand all" / "Collapse" actions. Presentational only — all state
 * (search term, expanded set, active-only flag) lives in the parent FilterPanel.
 */
export function FilterControlsRow(props: FilterControlsRowProps) {
  return (
    <div className="flex items-center justify-between">
      <label className="flex items-center gap-1.5 cursor-pointer select-none">
        <input
          type="checkbox"
          checked={props.showActiveOnly}
          onChange={(e) => props.onShowActiveOnlyChange(e.target.checked)}
          data-testid="show-active-only-checkbox"
          className="rounded border-[#DFE1E6] accent-[#0065FF]"
        />
        <span className="text-[12px] text-[#42526E]">Show active only</span>
      </label>
      <div className="inline-flex items-center gap-[6px]">
        <button
          onClick={props.onExpandAll}
          data-testid="expand-all-btn"
          className="hover:underline focus:outline-none"
          style={{fontSize: '12px', fontWeight: 500, color: '#0052CC'}}
        >
          Expand all
        </button>
        <span style={{color: '#C1C7D0'}}>·</span>
        <button
          onClick={props.onCollapseAll}
          data-testid="collapse-all-btn"
          className="hover:underline focus:outline-none"
          style={{fontSize: '12px', fontWeight: 500, color: '#0052CC'}}
        >
          Collapse
        </button>
      </div>
    </div>
  );
}
